var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateRequest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4627_33855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#11BBE0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4627_33855)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0833 39.4792C42.9236 36.4903 44.6666 32.4487 44.6666 28C44.6666 23.5513 42.9236 19.5096 40.0833 16.5208V39.4792ZM36.7499 13.8122C34.2067 12.2404 31.2093 11.3333 27.9999 11.3333C18.7952 11.3333 11.3333 18.7952 11.3333 28C11.3333 37.2047 18.7952 44.6666 27.9999 44.6666C31.2093 44.6666 34.2067 43.7595 36.7499 42.1877L36.7499 13.8122ZM23.9047 35.1548C23.2539 35.8057 23.2539 36.8609 23.9047 37.5118C24.5556 38.1627 25.6109 38.1627 26.2618 37.5118L32.7095 31.0641L32.7471 31.0265C33.0446 30.7291 33.3343 30.4395 33.5595 30.1741C33.8069 29.8827 34.0729 29.5129 34.2298 29.03C34.4473 28.3606 34.4473 27.6394 34.2298 26.9699C34.0729 26.4871 33.8069 26.1172 33.5595 25.8258C33.3342 25.5605 33.0445 25.2708 32.7471 24.9734L32.7095 24.9359L26.2618 18.4881C25.6109 17.8373 24.5556 17.8373 23.9047 18.4881C23.2539 19.139 23.2539 20.1943 23.9047 20.8452L29.3929 26.3333L15.9166 26.3333C14.9961 26.3333 14.2499 27.0795 14.2499 28C14.2499 28.9205 14.9961 29.6666 15.9166 29.6666L29.3929 29.6666L23.9047 35.1548Z",
    fill: "#BBEEEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4627_33855",
    x: -6,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4627_33855"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.101961 0 0 0 0 0.141176 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4627_33855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4627_33855",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4627_33855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create_request.159d10382d25a2cf0269ed43a6e387d7.svg";